import React, { Fragment, useState, useContext, useCallback } from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import UIPopupContext from "../../popups/UIPopup/UIPopupContext";
import {updatePromptParts} from "../aiApi";
import LoadingSpinner from "../../ui/loadingSpinner";
import TextInput from "../../ui/textInput";
import {hideGroupObject} from "../aiFunctions";
import UiPopupAIContentEditingModal from "./UiPopupAIContentEditingModal";
import {useAppDispatch, useAppSelector} from "../../../storeHooks";
import {setUiPopupState} from "../../../actions/actionFunctions";

const UiPopupAIContentFeatureGroups = (props) => {

  const {type} = props;

  const dispatch = useAppDispatch();
  const {uiPopupState} = useAppSelector(state => state.messageBoxState);

  const {uiPopupContext, uiPopupDispatch} = useContext(UIPopupContext);
  const {groupObjects, promptsList} = uiPopupContext;

  const [editingGroupObject, setEditingGroupObject] = useState(null);

  const isActiveType = "isActive" + type;
  const isActiveBody = "partBody" + type;
  const promptsPartsLoading = "promptsPartsLoading" + type;

  const onCheckboxClick = useCallback((gr) => {
    uiPopupDispatch({
      groupObjects: groupObjects.map((groupObject) => {
        if (groupObject.partId === gr.partId) {
          groupObject.enabled = !groupObject.enabled;
        }
        return groupObject;
      }),
    });
  }, [groupObjects, uiPopupDispatch]);

  const handleOpenEditor = (groupObject) => {
    dispatch(setUiPopupState({
      ...uiPopupState,
      style: {maxWidth: "95%", maxHeight: "95%"}
    }));
    setEditingGroupObject(groupObject);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  const handleCloseEditor = async (newValue) => {
    const groupObject = editingGroupObject;
    setEditingGroupObject(null);

    dispatch(setUiPopupState({
      ...uiPopupState,
      style: {maxWidth: "1280px", maxHeight: "640px"}
    }));

    if (!groupObject) return;

    // 1) update value in context
    uiPopupDispatch({
      groupObjects: groupObjects.map((gr) => {
        if (gr.partId === groupObject.partId) {
          return { ...gr, [isActiveBody]: newValue };
        }
        return gr;
      }),
    });

    // 2) persist (same logic you had onBlur)
    const activePrompt = promptsList.find((p) => p[isActiveType]);
    if (!activePrompt) return;

    // updatePromptParts expects the updated body on the groupObject param,
    // so pass a patched copy (safer than relying on async state updates)
    await updatePromptParts(
      { ...groupObject, [isActiveBody]: newValue },
      activePrompt,
      type
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  return (
    <Fragment>
      <ul className="ass-list pr-1 w-full">
        {groupObjects
          ? groupObjects.map((groupObject) => {
            if (hideGroupObject(groupObject)) return null;

            return (
              <li key={groupObject.featureGroup.partId} className="ass-list__item">
                <FormControlLabel
                  style={{ width: "150px", flex: "0 0 150px", lineHeight: 1 }}
                  className="ll-text bold color-primary text-left"
                  label={groupObject.featureGroup.dbName || groupObject.featureGroup.partName}
                  control={
                    <Checkbox
                      checked={groupObjects.some(
                        (gr) => gr.partId === groupObject.partId && gr.enabled
                      )}
                      onChange={() => onCheckboxClick(groupObject)}
                    />
                  }
                />

                {uiPopupContext[promptsPartsLoading] ? (
                  <LoadingSpinner size=" message-loading-left-panel-spinner message-loading-left-panel-spinner--30 w-3" />
                ) : (
                  <TextInput
                    className={"ui-input ui-input--new ui-input--gray"}
                    name={groupObject.partId}
                    value={groupObject[isActiveBody] || ""}
                    // open modal on focus/click
                    onFocus={() => handleOpenEditor(groupObject)}
                    onClick={() => handleOpenEditor(groupObject)}
                    onChange={() => null}
                    // prevent typing in the tiny input
                    readOnly
                  />
                )}
              </li>
            );
          })
          : null}
      </ul>

      <UiPopupAIContentEditingModal
        propsOpened={!!editingGroupObject}
        propsValue={editingGroupObject?.[isActiveBody] || ""}
        propsTitle={
          editingGroupObject?.featureGroup?.dbName || editingGroupObject?.featureGroup?.partName || ""
        }
        propsClose={handleCloseEditor}
      />
    </Fragment>
  );
};

const mapStateToProps = (store) => {
  const fabricatorData = store.fabricatorState;

  return {
    fabricatorData,
  };
};

export default injectIntl(
  connect(mapStateToProps)(UiPopupAIContentFeatureGroups)
)

